import { render, staticRenderFns } from "./studentTemplate.vue?vue&type=template&id=552e3d16&scoped=true"
import script from "./studentTemplate.vue?vue&type=script&lang=js"
export * from "./studentTemplate.vue?vue&type=script&lang=js"
import style0 from "./studentTemplate.vue?vue&type=style&index=0&id=552e3d16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e3d16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552e3d16')) {
      api.createRecord('552e3d16', component.options)
    } else {
      api.reload('552e3d16', component.options)
    }
    module.hot.accept("./studentTemplate.vue?vue&type=template&id=552e3d16&scoped=true", function () {
      api.rerender('552e3d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/studentTemplate.vue"
export default component.exports